import {IFullTemplateField} from '../_interface/itemplate-field';

export const templateFieldById = (templateFieldId: string, fields: IFullTemplateField[]): IFullTemplateField =>
	fields.find(f => f.templateFieldId === templateFieldId);
